import React__default, { useState, useEffect } from 'react';
import { Switch as Switch$1 } from 'react-aria-components';
import './Switch.scss';

const Switch = (props) => {
    const [selected, setSelected] = useState(props.isSelected ?? props.defaultSelected ?? false);
    // Sync internal state if isSelected prop changes
    useEffect(() => {
        if (props.isSelected !== undefined) {
            setSelected(props.isSelected);
        }
    }, [props.isSelected]);
    const handleChange = (newSelected) => {
        if (props.isDisabled) {
            return;
        }
        setSelected(newSelected);
        props.onChange?.(newSelected);
    };
    return (React__default.createElement(Switch$1, { ...props, "data-rev-component": 'switch', "data-disabled": props.isDisabled ? true : undefined, onChange: () => handleChange(!selected) },
        props.label && props.labelSide === 'left' && (React__default.createElement("div", { className: 'switch-label--rev' }, props.label)),
        React__default.createElement("div", { className: 'switch-indicator--rev' }),
        props.label && props.labelSide === 'right' && (React__default.createElement("div", { className: 'switch-label--rev' }, props.label))));
};
Switch.displayName = 'Switch';

export { Switch };
//# sourceMappingURL=Switch.js.map
